/*eslint no-useless-computed-key: "off"*/
import React from "react";
import PropTypes from "prop-types";
// import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";

import MobileButton from "componentsCustom/Mobile/MobileButton.js";

import mobileWrapper from "assets/jss/material-dashboard-pro-react/componentsCustom/mobileWrapper.js";

const useStyles = makeStyles(mobileWrapper);

export default function MobileWrapper(props) {
  const {
    children,
    buttons,
    showButtons,
    type,
    containerClasses,
    containerMobileButton,
  } = props;
  // const { t } = useTranslation();
  const classes = useStyles();

  let h = 60;
  if (buttons && buttons.length >= 1) {
    h += (buttons.length - 1) * 50;
  }
  if (!showButtons) {
    h = 0;
  }

  return (
    <div
      className={`${classes.container}${
        containerClasses ? ` ${containerClasses}` : ""
      }`}
     // style={{ marginBottom: `${h}px` }}
    >
      {children}
{/*      {byEmma}*/}
      <Hidden mdUp implementation="css">
        {showButtons && buttons && buttons.length >= 1 ? (
          <div
            className={`${classes.containerMobileButton}${
              containerMobileButton ? ` ${containerMobileButton}` : ""
            }`}
            style={{
              height: `${h}px`,
              zIndex: 14
            }}
          >
            {buttons.map((button, index) => {
              return (
                <MobileButton
                  key={`Button_${button.text}_${type}`}
                  {...button}
                  index={index}
                  type={type}
                  nButtons={buttons.length}
                />
              );
            })}
          </div>
        ) : null}
      </Hidden>
    </div>
  );
}

MobileWrapper.propTypes = {
  containerClasses: PropTypes.string,
  containerMobileButton: PropTypes.string,
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      color: PropTypes.string,
      text: PropTypes.string,
      isActive: PropTypes.bool,
      path: PropTypes.string,
      className: PropTypes.string,
      classNameText: PropTypes.string
    })
  ),
  showButtons: PropTypes.bool
};
MobileWrapper.defaultProps = {
  containerClasses: "",
  showButtons: false,
  buttons: [],
  type: "delivery"
};
